import React from "react";
import { Button, Checkbox, Dropdown, Message, Segment, Tab, Table,Card, Modal, ModalContent, ModalDescription, ModalHeader, Grid, Icon  } from "semantic-ui-react";
import './WorkingSchedules.less';
import {useEffect, useState} from 'react';
import moment from "moment";
import _ from 'lodash';
import { withRouter, useLocation } from "react-router";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import {getSellerSchedules as _getSellerSchedules, getDaysOfWeek as _getDaysOfWeek, updateSellerSchedule} from '../../services/Seller';
import 'react-notifications/lib/notifications.css';
import { NotificationManager } from 'react-notifications';
import next from '../../assets/images/newui/sellersignup/next-btn.svg'

const WorkingSchedules = ({ history}) => {
    const noticationTimeout = 2500;

    const [workingScheduleData, setWorkingScheduleData] = useState([]);
    const [daysOfWeek, setDaysOfWeek] = useState([]);
    const [selectedScheduleID, setSelectedScheduleID] = useState(0);
    const [selectedDay, setSelectedDay] = useState('');
    const [startTime, setStartTime] = useState('');
    const [endTime, setEndTime] = useState('');
    const [isActive, setIsActive] = useState(true);
    const [viewModal, setViewModal] = useState(false);
    //const [isFullDay, setIsFullDay] = useState(false);
    const [message, setMessage] = useState('');
    const location = useLocation();
    const [isReferred, setIsReferred] = useState(false)

    useEffect(() => {
        setTimeout(() => {
            setMessage('')
        }, 3000);
    }, message);

    useEffect(async() => {
        await getDaysOfWeek();
       await getSellerSchedules();
       if(location.state?.referrer == 'cp'){
        setIsReferred(true);
       }
       
    },[])

    const getDaysOfWeek = async () => {
        const daysOfWeek = await _getDaysOfWeek();
        if(daysOfWeek.resStatus == 200){
            const days = _.map(daysOfWeek.data, (value) => {
                return {key: value.dayID, text: value.name, value: value.dayID}

            });
            setDaysOfWeek(days);

        }

    }

    const getSellerSchedules = async () => {
        const sellerSchedules = await _getSellerSchedules();
        if(sellerSchedules.resStatus == 200)
        {
            setWorkingScheduleData(sellerSchedules.data);
        }
    }

    // const onSelectedScheduleDayChange = (e, data) => {
    //     setSelectedDay(data.value);
    // }

    const onSelectedStartTimeChange = (data) => {
        setStartTime(data);
    }

    const onIsActiveChange = (e, data) => {
        setIsActive(data.checked);
    }
    const onClickEditSchedule = (schedule) => {
        
        setViewModal(true);
        setIsActive(schedule.isActive);
        setSelectedScheduleID(schedule.sellerScheduleID);
        setSelectedDay(schedule.dayName);

        const sTime = moment(schedule.startTime, 'HH:mm');
        const eTime = moment(schedule.endTime, 'HH:mm');

        const sDate = new Date();
        sDate.setHours(sTime.get('hour'));
        sDate.setMinutes(sTime.get('minute'));
        setStartTime(sDate);

        const eDate = new Date();
        eDate.setHours(eTime.get('hour'));
        eDate.setMinutes(eTime.get('minute'));
        setEndTime(eDate);

        //const sTime = _.split(schedule.startTime,":");
        //const eTime = _.split(schedule.startTime,":");
        // dt.setHours(parseInt(sTime[0]));
        // dt.setMinutes(parseInt(sTime[1]));
        // setStartTime(dt);
        // dt.setHours(parseInt(eTime[0]));
        // dt.setMinutes(parseInt(eTime[1]));
        
    }

    const onModalClose = () =>{
        setViewModal(false);
    }

    const updateSchedule = async() => {
        if (startTime >= endTime) {
            NotificationManager.error("Start time must be earlier than end time.", '', noticationTimeout);
        }
        else {
            const sTime = startTime.getHours().toString().padStart(2, '0') + ':' + startTime.getMinutes().toString().padStart(2, '0');
            const eTime = endTime.getHours().toString().padStart(2, '0') + ':' + endTime.getMinutes().toString().padStart(2, '0');
            const res = await updateSellerSchedule(selectedScheduleID, sTime, eTime, isActive);

            if (res && res.resStatus == 200) {
                const updateSchedule = workingScheduleData.map((schedule, i) => {
                    if (schedule.sellerScheduleID == selectedScheduleID) {
                        schedule.isActive = isActive;
                        schedule.startTime = sTime;
                        schedule.endTime = eTime;
    
                    }
                    return schedule;
                });
                setWorkingScheduleData(updateSchedule);

                NotificationManager.success(res.message, '', noticationTimeout);
                setViewModal(false);
            }
            else {
                NotificationManager.error("An error occurred while updating schedule.", '', noticationTimeout);
            }

            
        }
        
    }

    const updateScheduleStatus = async (e, data) => {
        let scheduleID = data.value;
        const updateSchedule = workingScheduleData.map((schedule, i) => {
            if (schedule.sellerScheduleID == scheduleID) {
                schedule.isActive = data.checked;
                
            }
            return schedule;
        });

        const scheduleItem = workingScheduleData.filter(sch => {
            return sch.sellerScheduleID == scheduleID;
        });

        const res = await updateSellerSchedule(scheduleItem[0].sellerScheduleID, scheduleItem[0].startTime, scheduleItem[0].endTime, scheduleItem[0].isActive);
        if(res && res.resStatus == 200)
        {
            setWorkingScheduleData(updateSchedule);
            NotificationManager.success(res.message, '', noticationTimeout);
        }
        else
        {
            NotificationManager.error("An error occurred while updating schedule.", '', noticationTimeout);
        }
        
    }

    const onNextClick = () => {
        history.push({pathname:'/invoice/settings', state: {referrer: "cp"}});
    }

    return <div className="schedule-container">
        {/* <Segment> */}
            
            {isReferred && <div className="schedule-setting-msg"><div>Please setup your business hours. </div><div>We will send you new customers during these hours</div></div> }
            <Segment>
            <h1 className="main-heading"><Icon name='calendar' size='small' /> Business Hours</h1>
                {window.innerWidth > 767 ?
                <Table>
                    <Table.Header>
                        <Table.HeaderCell>
                            Day
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Start
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            End
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            Active
                        </Table.HeaderCell>
                        <Table.HeaderCell>
                            
                        </Table.HeaderCell>
                    </Table.Header>
                    
                    {workingScheduleData.map(schedule => 
                        <Table.Row>
                        <Table.Cell>
                            {schedule.dayName}
                        </Table.Cell>
                        <Table.Cell>
                            {schedule.startTime}
                        </Table.Cell>
                        <Table.Cell>
                            {schedule.endTime}
                        </Table.Cell>
                            <Table.Cell>
                                <Checkbox toggle
                                    name= "chkIsActive"
                                    checked={schedule.isActive}
                                    onChange={updateScheduleStatus}
                                    value={schedule.sellerScheduleID}
                                    className="chk-active chk-active-desktop"
                                />
                                {/* {schedule.isActive ? 'Active' : 'Inactive'} */}
                            </Table.Cell>
                        <Table.Cell>
                            <Button className="blue btn-edit" onClick={() => onClickEditSchedule(schedule)}>Edit</Button>
                        </Table.Cell>
                    </Table.Row>
                    )}
                </Table>
        : 
                <div>
                    {workingScheduleData.map(schedule =>
                    <Card fluid className="card-mobile">
                        <Card.Content>
                                <Card.Header className="modal-day">
                                    <div className="modal-div-day">
                                        <span className="modal-span-day">
                                        {schedule.dayName}
                                        <Checkbox toggle
                                            name="chkIsActive"
                                            checked={schedule.isActive}
                                            onChange={updateScheduleStatus}
                                            value={schedule.sellerScheduleID}
                                            className="chk-active"
                                        />
                                        </span>
                                        <span className="modal-span-btn">
                                        <Button className="blue btn-edit-mobile" onClick={() => onClickEditSchedule(schedule)}>Edit</Button>
                                        </span>
                                    </div>
                                </Card.Header>
                            
                        </Card.Content>
                        <Card.Content>
                            <Card.Description>
                                <b>Start:</b> {schedule.startTime}
                            </Card.Description>
                        </Card.Content>
                        <Card.Content>
                            <Card.Description>
                                <b>End:</b> {schedule.endTime}
                            </Card.Description>
                        </Card.Content>
                        
                    </Card>
                    )}
                </div>    
        }
            </Segment>

            {isReferred && <div className="next-button-container">
                <button className='invoice-submit-btn' type='button' onClick={onNextClick}>NEXT <img src={next} /></button>
            </div>}

            <Modal size='mini' open={viewModal} onClose={onModalClose} className="modal-update">
            <Modal.Header className="modal-header">
                <span className="modal-header-label">
                
                    Update Schedule
                </span>
            </Modal.Header>
                <ModalContent>
                    <div className="div-day-main">
                        <div className="div-day">
                            <span className="span-day-text">{selectedDay}</span>
                            <span className="span-day-checkbox">
                                <Checkbox toggle
                                    name="chkIsActive"
                                    checked={isActive}
                                    onChange={onIsActiveChange}
                                    className="chk-active"
                                />
                            </span>
                        </div>
                    </div>
                    {/* <Grid>
                        <Grid.Row>
                            <Grid.Column computer={4}>
                                <b>Day :</b>
                            </Grid.Column>
                            <Grid.Column computer={12}>
                                {selectedDay}
                                <Checkbox toggle
                                    name="chkIsActive"
                                    checked={isActive}
                                    onChange={onIsActiveChange}
                                />
                            </Grid.Column>
                        </Grid.Row>
                    </Grid> */}
                    {/* <ModalDescription>
                    {selectedDay} 
                        <Checkbox toggle
                            name="chkIsActive"
                            checked={isActive}
                            onChange={onIsActiveChange}
                        />
                    </ModalDescription> */}
                </ModalContent>
                <ModalContent>
                    <div className="div-time-main">
                        <div className="div-time-control">
                            <span className="span-startTime">
                                <div className="div-startTime-label">Start</div>
                                <DatePicker
                                    selected={startTime}
                                    onChange={(date) => onSelectedStartTimeChange(date)}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    timeCaption={false}
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="sTime time-control"
                                />
                            </span>
                            <span className="span-startTime">
                            <div className="div-endTime-label">End</div>
                                <DatePicker
                                    selected={endTime}
                                    onChange={(date) => setEndTime(date)}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    timeCaption={false}
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="eTime time-control"
                                />
                            </span>
                        </div>
                        
                    </div>
                    {/* <Grid>
                        <Grid.Row>
                            <Grid.Column computer={4}>
                                <b>Start :</b>
                            </Grid.Column>
                            <Grid.Column computer={12}>
                                <DatePicker
                                    selected={startTime}
                                    onChange={(date) => onSelectedStartTimeChange(date)}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    timeCaption={false}
                                    //timeCaption="Start Time"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="sTime"
                                />
                            </Grid.Column>
                        </Grid.Row>
                        <Grid.Row>
                            <Grid.Column computer={4}>
                                <b>End :</b>
                            </Grid.Column>
                            <Grid.Column computer={12}>
                                <DatePicker
                                    selected={endTime}
                                    onChange={(date) => setEndTime(date)}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={30}
                                    timeCaption={false}
                                    //timeCaption="End Time"
                                    dateFormat="HH:mm"
                                    timeFormat="HH:mm"
                                    className="eTime"
                                />
                            </Grid.Column>
                        </Grid.Row>



                    </Grid> */}
                </ModalContent>
                <Modal.Actions className="modal-action">
                    <div className="div-action">
                        <span className="span-btn-cancel">
                            <Button content='CANCEL' onClick={onModalClose} className="btn-action btn-action-cancel" />
                        </span>
                        <span className="span-btn-update">
                            <Button content='UPDATE' onClick={updateSchedule} className="blue btn-action btn-action-update" />
                        </span>
                    </div>
                </Modal.Actions>
            </Modal>
            
        {/* </Segment> */}

    </div>

}
export default withRouter(WorkingSchedules);